import type { ReactNode } from 'react';
import { cn } from '../cn.js';

export interface EmptyStateProps {
  icon?: ReactNode;
  title: string;
  description?: string;
  action?: ReactNode;
  className?: string;
}

/** A friendly placeholder shown when a list or screen has no content. */
export function EmptyState({ icon, title, description, action, className }: EmptyStateProps): JSX.Element {
  return (
    <div className={cn('as-empty', className)}>
      {icon && <div className="as-empty__icon">{icon}</div>}
      <h3 className="as-empty__title">{title}</h3>
      {description && <p className="as-empty__desc">{description}</p>}
      {action && <div className="as-empty__action">{action}</div>}
    </div>
  );
}
